<template>
  <dr-wrapper v-if="isInEditorMode" v-bind="$props" v-on="wrapOn">
    <v-btn
      :icon="this.model.IconMode"
      :disabled="isDisabled"
      :class="evaluateClasses(classes)"
      :color="evalColorExpression(model.Color)"
      :rounded="isRounded"
      :outlined="isOutlined"
      :plain="isPlain"
      :raised="isRaised"
      :text="isText"
    >
      <v-icon v-if="model.IconName">{{
        getExternalSourceField(this.model.IconName)
      }}</v-icon>
      {{ evaluateExpression(model.Caption) }}
    </v-btn>
  </dr-wrapper>
  <div v-else-if="isVisible">
    <!-- <EdsCreate ref="edsCreateDialog" @edsChangeLoadStatus="onChangeLoadStatus"/> -->
    <v-btn
      :icon="this.model.IconMode"
      :disabled="isDisabled"
      :class="evaluateClasses(classes)"
      @click="sign"
      :color="evaluateExpression(model.Color)"
      :rounded="isRounded"
      :outlined="isOutlined"
      :plain="isPlain"
      :raised="isRaised"
      :text="isText"
      :loading="loading"
    >
      <v-icon v-if="model.IconName">{{
        getExternalSourceField(this.model.IconName)
      }}</v-icon>
      {{ evaluateExpression(model.Caption) }}
    </v-btn>
  </div>
</template>

<script>
import inputMixin from '../../../mixins/input-mixin'
import baseMixin from '../../../mixins/base-mixin'

export default {
  mixins: [inputMixin, baseMixin],
  data: () => ({
    attachmentParams: {},
    loading: false,
    edsCreateDialog: null
  }),
  mounted() {
    this.edsCreateDialog = this.findEds(this.$options.parent)
  },
  methods: {
    async sign() {
      if (!this.edsCreateDialog) {
        return
      }
      this.loading = true
      const sign = await this.edsCreateDialog.signFile({ fileUrl: this.getDataSourceField(this.model.FileUrl) })
      if (sign) {
        this.setDataSourceField(this.model.FileSignature, sign)
      }
      this.loading = false
    },
    onMountedEdsCreate() {
      this.$options.resolveFunction()
    },
    // finding an instance eds
    findEds(parent) {
      if (parent.$refs['edsCreateWrapper']) {
        return parent.$refs['edsCreateWrapper']
      }
      return this.findEds(parent.$parent)
    }
  },
  computed: {
    // styling a button
    isRounded() {
      return this.model.isRounded
    },
    isOutlined() {
      return this.model.isOutlined
    },
    isPlain() {
      return this.model.isPlain
    },
    isRaised() {
      return this.model.isRaised
    },
    isText() {
      return this.model.isText
    },
    isPopUpMenu() {
      return this.model.OnClickAction.Type === 'PopUpMenu'
    }
  }
}
</script>

<style>
</style>